<template>
  <b-modal id="send-message-modal">
    <div class="p-3">
      <validation-observer ref="observer">
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-if="Array.isArray(error)">
            <div
              class="d-flex flex-column my-1"
              v-for="(error_text, index) in error"
              :key="index"
            >
              {{ error_text }}
            </div>
          </div>
          <div v-else>
            <div v-html="error || '&nbsp;'"></div>
          </div>
        </b-alert>
        <div>
          <base-textarea
            id="send-message-modal-message"
            label="message"
            name="message"
            placeholder="please-enter-message"
            rules="required"
            :is_required="true"
            field="message"
            :value="message"
            :disabled="loading"
            @change-value="setValue"
          ></base-textarea>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <div class="m-1">
            <base-button
              id="send-message-modal-submit-btn"
              variant="primary"
              :loading="loading"
              @click="submit"
            >
              {{ $t('send') }}
            </base-button>
          </div>
          <div class="m-1">
            <base-button
              id="send-message-modal-cancel-btn"
              variant="secondary"
              :disabled="loading"
              @click="close"
            >
              {{ $t('cancel') }}
            </base-button>
          </div>
        </div>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import DriverService from "@/services/driver.service";

export default {
  props: ["data"],
  data() {
    return {
      loading: false,
      message: "",
      error: null,
    };
  },
  methods: {
    setValue(val, field) {
      this[field] = val;
    },
    async submit() {
      const valid = await this.$refs.observer.validate();
      if (!valid) return;
      else {
        this.error = null;
        this.loading = true;

        DriverService.post({
          message: this.message,
          phoneNumber: this.data.phone_number,
        }, "send-sms")
          .then(() => {
            this.close();
          })
          .catch(({ message }) => {
            this.error = message;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    close() {
      this.$bvModal.hide("send-message-modal");
      this.loading = false;
      this.message = "";
      this.error = null;
    },
  },
};
</script>
